<template>
  <div>
    <!-- 작업기간 -->
    <div class="form-group row">
      <label class="col-2 form-control-label"><span>작업기간</span></label>
      <div class="col-6 pt-2">
        <DatePicker class="form-control" type="date" range :append-to-body="true"
          v-model="permit.workPeriod"
          :clearable="false" :editable="false"
          :disabled-date="scheduleDateDisabledFn"
          style="font-size: 12px;"
          input-class="calendar-input">
          <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
        </DatePicker>
      </div>
    </div>

    <!-- 운전원 -->
    <div class="form-group row mt-20">
      <label class="col-2 form-control-label"><span>운전원</span></label>
      <div class="col-10 pt-2">
        <div class="btn-wrap mb-10">
          <button class="btn btn-md light-blue" @click="addExcavationOperator">
            <i class="icon-plus mr-5"></i>행 추가
          </button>
          <button class="btn btn-md line-2" @click="$emit('load-operators')">
            <i class="icon-refresh mr-5"></i>중량물작업계획서에서 가져오기
          </button>
        </div>
        <table class="tbl select-tbl">
          <colgroup><col><col><col><col style="width:80px;"></colgroup>
          <thead class="no-drag">
            <tr><th>성명</th><th>면허</th><th>연락처</th><th></th></tr>
          </thead>
          <tbody>
            <tr v-for="(op, idx) in permit.operators" :key="idx">
              <td><input type="text" class="form-control" v-model="op.name" placeholder="성명"></td>
              <td><input type="text" class="form-control" v-model="op.license" placeholder="면허종류"></td>
              <td><input type="text" class="form-control" v-model="op.phone" placeholder="연락처"></td>
              <td style="text-align:center;">
                <button class="btn btn-xs line-2" @click="permit.operators.splice(idx,1)" :disabled="permit.operators.length === 1">삭제</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 유도자 -->
    <div class="form-group row mt-20">
      <label class="col-2 form-control-label"><span>유도자</span></label>
      <div class="col-10 pt-2">
        <div class="btn-wrap mb-10">
          <button class="btn btn-md light-blue" @click="addExcavationGuide">
            <i class="icon-plus mr-5"></i>행 추가
          </button>
          <button class="btn btn-md line-2" @click="$emit('load-guides')">
            <i class="icon-refresh mr-5"></i>중량물작업계획서에서 가져오기
          </button>
        </div>
        <table class="tbl select-tbl">
          <colgroup><col><col><col><col style="width:80px;"></colgroup>
          <thead class="no-drag">
            <tr><th>성명</th><th>신호방법</th><th>연락처</th><th></th></tr>
          </thead>
          <tbody>
            <tr v-for="(guide, idx) in permit.guides" :key="idx">
              <td><input type="text" class="form-control" v-model="guide.name" placeholder="성명"></td>
              <td style="vertical-align:middle;">
                <label class="md-check mr-20"><input type="checkbox" v-model="guide.signalMethods" value="수신호"><i class="blue"></i>수신호</label>
                <label class="md-check"><input type="checkbox" v-model="guide.signalMethods" value="무선"><i class="blue"></i>무선</label>
                <input v-if="guide.signalMethods && guide.signalMethods.includes('무선')" type="text" class="form-control mt-5" v-model="guide.wirelessMeans" placeholder="무선수단 입력 (예: 무전기/채널)">
              </td>
              <td><input type="text" class="form-control" v-model="guide.phone" placeholder="연락처"></td>
              <td style="text-align:center;">
                <button class="btn btn-xs line-2" @click="permit.guides.splice(idx,1)" :disabled="permit.guides.length === 1">삭제</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 기계·장비 제원 -->
    <div class="form-group row mt-20">
      <label class="col-2 form-control-label"><span>기계·장비 제원</span></label>
      <div class="col-10 pt-2">
        <div class="btn-wrap mb-10">
          <button class="btn btn-md line-2" @click="$emit('load-equipment')">
            <i class="icon-refresh mr-5"></i>중량물작업계획서에서 가져오기
          </button>
        </div>
        <div v-for="(equip, eIdx) in permit.equipmentList" :key="equip.id" class="box mb-10">
          <div class="box-header" style="display:flex;justify-content:space-between;align-items:center;padding:8px 12px;">
            <span style="font-weight:600;">장비 {{ eIdx + 1 }}</span>
            <button class="btn btn-xs line-2" @click="removeExcavationEquipment(eIdx)"
              :disabled="permit.equipmentList.length === 1">삭제</button>
          </div>
          <div class="box-body">
            <EquipCommonFields :equip="equip" :markRequired="true" :placeholders="{ modelName: '굴착기(CAT-000)', manufacturer: '00 기계', registrationNo: '부산 02가 0000', manufactureYear: '0000년', insuranceName: '00 보험' }">
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0"><span class="ess">구동형식</span></label>
                <div class="col-10">
                  <label class="md-check mr-20"><input type="radio" v-model="equip.driveType" value="타이어식"><i class="blue"></i>타이어식</label>
                  <label class="md-check mr-20"><input type="radio" v-model="equip.driveType" value="무한궤도식"><i class="blue"></i>무한궤도식</label>
                </div>
              </div>
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0">제한속도(km/h)</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.speedLimit" placeholder="00 km/h"></div>
                <label class="col-2 form-control-label pt-0">장비중량(ton)</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.equipWeight" placeholder="00 ton"></div>
              </div>
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0">선회반경(m)</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.turningRadius" placeholder="전.측방 00m / 후방 00m"></div>
              </div>
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0"><span class="ess">정격하중(ton)</span></label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.ratedLoad" placeholder="00 ton"></div>
                <label class="col-2 form-control-label pt-0">최대인양높이(m)</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.maxLiftHeight" placeholder="00 m"></div>
              </div>
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0">붐·암 최대높이(m)</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.boomMaxHeight" placeholder="00 m"></div>
                <label class="col-2 form-control-label pt-0">붐·암 길이(m)</label>
                <div class="col-4"><input type="text" class="form-control" v-model="equip.boomLength" placeholder="표준: 00 m / 최대: 00 m"></div>
              </div>
            </EquipCommonFields>
            <div class="form-group row mb-0">
              <label class="col-2 form-control-label pt-0"><span class="ess">작업장치</span></label>
              <div class="col-10">
                <label class="md-check mr-15" v-for="d in ['버킷','브레이커','크램셀','인양용 달기구']" :key="d">
                  <input type="checkbox" v-model="equip.workDevices" :value="d"><i class="blue"></i>{{ d }}
                </label>
                <label class="md-check mr-10"><input type="checkbox" v-model="equip.workDeviceOther"><i class="blue"></i>기타</label>
                <input v-if="equip.workDeviceOther" type="text" class="form-control mt-5"
                       v-model="equip.workDeviceOtherText" placeholder="기타 작업장치" style="max-width:300px;">
              </div>
            </div>
          </div>
        </div>
        <button class="btn btn-md light-blue" @click="addExcavationEquipment">
          <i class="icon-plus mr-5"></i>장비 추가
        </button>
      </div>
    </div>

    <!-- 작업장소의 지형·지반 상태 등 사전 조사내용 -->
    <div class="form-group row mt-20">
      <label class="col-2 form-control-label"><span>작업장소의 지형·지반 상태 등 사전 조사내용</span></label>
      <div class="col-10 pt-2">
        <!-- 지하매설물 조사 -->
        <div class="form-group row mb-10">
          <label class="col-2 form-control-label pt-0"><span class="ess">지하매설물 조사</span></label>
          <div class="col-10">
            <table class="tbl select-tbl" style="width:100%;">
              <colgroup>
                <col width="120px">
                <col width="220px">
                <col>
              </colgroup>
              <thead class="no-drag">
                <tr><th>구분</th><th>확인결과</th><th>조치여부</th></tr>
              </thead>
              <tbody>
                <tr v-for="item in permit.siteInvestigation.underground" :key="item.name">
                  <td style="vertical-align:middle;">{{ item.name }}</td>
                  <td style="vertical-align:middle;">
                    <label class="md-check mr-15"><input type="radio" v-model="item.applicable" :value="true"><i class="blue"></i>해당</label>
                    <label class="md-check"><input type="radio" v-model="item.applicable" :value="false" @change="item.measure = ''"><i class="blue"></i>해당없음</label>
                  </td>
                  <td style="vertical-align:middle;">
                    <input type="text" class="form-control" v-model="item.measure"
                           :disabled="item.applicable !== true"
                           :placeholder="item.applicable === true ? '조치내용' : '해당 시 입력'"
                           :style="(item.applicable === true && !(item.measure || '').trim()) ? { borderColor:'#eb5757' } : {}">
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- 작업장소의 지형·지반 상태 -->
        <div class="form-group row mt-15 mb-10">
          <label class="col-2 form-control-label pt-0">작업장소의 지형·지반 상태</label>
          <div class="col-10">
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0">지반 종류</label>
              <div class="col-10" style="display:flex;flex-wrap:wrap;align-items:center;gap:8px 16px;">
                <label class="md-check mr-15" v-for="g in ['모래','흙','아스팔트','보도블럭']" :key="g">
                  <input type="checkbox" v-model="permit.siteInvestigation.groundTypes" :value="g"><i class="blue"></i>{{ g }}
                </label>
                <label class="md-check mr-10"><input type="checkbox" v-model="permit.siteInvestigation.groundTypeOther"><i class="blue"></i>기타</label>
                <input v-if="permit.siteInvestigation.groundTypeOther" type="text" class="form-control"
                       v-model="permit.siteInvestigation.groundTypeOtherText" placeholder="기타 지반 종류 (필수)"
                       :style="{ maxWidth:'200px', ...((permit.siteInvestigation.groundTypeOtherText || '').trim() ? {} : { borderColor:'#eb5757' }) }">
              </div>
            </div>
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0">지반 상태</label>
              <div class="col-10">
                <div style="display:flex;flex-wrap:wrap;align-items:center;gap:8px 16px;">
                  <label class="md-check">
                    <input type="checkbox" v-model="permit.siteInvestigation.slopeCheck"><i class="blue"></i>경사
                  </label>
                  <input v-if="permit.siteInvestigation.slopeCheck" type="text" class="form-control" v-model="permit.siteInvestigation.slopeText" placeholder="1:1 (필수)"
                         :style="{ width:'100px', ...((permit.siteInvestigation.slopeText || '').trim() ? {} : { borderColor:'#eb5757' }) }">
                  <label class="md-check mr-15" v-for="c in ['견고','연약','동결']" :key="c">
                    <input type="checkbox" v-model="permit.siteInvestigation.conditions" :value="c"><i class="blue"></i>{{ c }}
                  </label>
                  <label class="md-check">
                    <input type="checkbox" v-model="permit.siteInvestigation.specialNoteCheck"><i class="blue"></i>특이사항
                  </label>
                  <input v-if="permit.siteInvestigation.specialNoteCheck" type="text" class="form-control" v-model="permit.siteInvestigation.specialNoteText" placeholder="특이사항 입력 (필수)"
                         :style="{ width:'200px', ...((permit.siteInvestigation.specialNoteText || '').trim() ? {} : { borderColor:'#eb5757' }) }">
                </div>
              </div>
            </div>
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0">지하수위 등 함수상태</label>
              <div class="col-10" style="display:flex;align-items:center;gap:12px;">
                <label class="md-check"><input type="radio" v-model="permit.siteInvestigation.groundwaterStatus" value="양호"><i class="blue"></i>양호</label>
                <label class="md-check"><input type="radio" v-model="permit.siteInvestigation.groundwaterStatus" value="불량"><i class="blue"></i>불량</label>
                <input v-if="permit.siteInvestigation.groundwaterStatus === '불량'" type="text" class="form-control"
                       v-model="permit.siteInvestigation.groundwaterMeasure" placeholder="조치내용" style="flex:1;min-width:0;">
              </div>
            </div>
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0">
                <span v-tooltip.top="{ content: '평균 접지압 이상의 값', classes: ['wp-risk-tooltip'] }"
                      style="display:inline-flex;align-items:center;justify-content:center;width:15px;height:15px;border-radius:50%;background:#888;color:#fff;font-size:10px;cursor:help;margin-right:4px;">?</span>
                <span class="ess">필요 지내력</span>
              </label>
              <div class="col-4"><input type="text" class="form-control" v-model="permit.siteInvestigation.requiredLoadCapacity"></div>
              <label class="col-2 form-control-label pt-0">작업장소 지내력</label>
              <div class="col-4"><input type="text" class="form-control" v-model="permit.siteInvestigation.actualLoadCapacity"></div>
            </div>
            <div class="form-group row mb-0">
              <label class="col-2 form-control-label pt-0"><span class="ess">지반 보강방법</span></label>
              <div class="col-10">
                <label class="md-check mr-15" v-for="r in ['철판설치','지반개량','양질토사','성토']" :key="r">
                  <input type="checkbox" v-model="permit.siteInvestigation.reinforcementMethods" :value="r" @change="onReinforceChange(r)"><i class="blue"></i>{{ r }}
                </label>
                <label class="md-check mr-10"><input type="checkbox" v-model="permit.siteInvestigation.reinforcementOther" @change="onReinforceOtherChange"><i class="blue"></i>기타</label>
                <input v-if="permit.siteInvestigation.reinforcementOther" type="text" class="form-control mt-5"
                       v-model="permit.siteInvestigation.reinforcementOtherText" placeholder="기타 보강방법" style="max-width:300px;">
                <label class="md-check ml-15"><input type="checkbox" v-model="permit.siteInvestigation.reinforcementMethods" value="해당없음" @change="onReinforceChange('해당없음')"><i class="blue"></i>해당없음</label>
              </div>
            </div>
          </div>
        </div>

        <!-- 주변작업·이동 및 지장물 간섭 -->
        <div class="form-group row mt-15 mb-0">
          <label class="col-2 form-control-label pt-0">주변작업·이동 및 지장물 간섭</label>
          <div class="col-10">
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0"><span class="ess">작업반경 내 출입금지 조치</span></label>
              <div class="col-10">
                <label class="md-check mr-15" v-for="a in ['유도자','접근방지 로프','칼라콘']" :key="a">
                  <input type="checkbox" v-model="permit.siteInvestigation.accessRestrictions" :value="a"><i class="blue"></i>{{ a }}
                </label>
                <label class="md-check mr-10"><input type="checkbox" v-model="permit.siteInvestigation.accessRestrictionOther"><i class="blue"></i>기타</label>
                <input v-if="permit.siteInvestigation.accessRestrictionOther" type="text" class="form-control mt-5"
                       v-model="permit.siteInvestigation.accessRestrictionOtherText" placeholder="기타 조치" style="max-width:300px;">
              </div>
            </div>
            <div class="form-group row mb-10">
              <label class="col-2 form-control-label pt-0"><span class="ess">주변 가공전선 접촉 가능 여부</span></label>
              <div class="col-10" style="display:flex;align-items:center;gap:12px;">
                <label class="md-check" style="white-space:nowrap;"><input type="radio" v-model="permit.siteInvestigation.nearbyPowerLines" value="있음"><i class="blue"></i>있음</label>
                <label class="md-check" style="white-space:nowrap;"><input type="radio" v-model="permit.siteInvestigation.nearbyPowerLines" value="없음"><i class="blue"></i>없음</label>
                <input v-if="permit.siteInvestigation.nearbyPowerLines === '있음'" type="text" class="form-control"
                       v-model="permit.siteInvestigation.nearbyPowerLinesMeasure" placeholder="조치내용" style="flex:1;min-width:0;">
              </div>
            </div>
            <div class="form-group row mb-0">
              <label class="col-2 form-control-label pt-0"><span class="ess">주변 지장물 간섭 여부</span></label>
              <div class="col-10" style="display:flex;align-items:center;gap:12px;">
                <label class="md-check" style="white-space:nowrap;"><input type="radio" v-model="permit.siteInvestigation.nearbyObstacle" value="있음"><i class="blue"></i>있음</label>
                <label class="md-check" style="white-space:nowrap;"><input type="radio" v-model="permit.siteInvestigation.nearbyObstacle" value="없음"><i class="blue"></i>없음</label>
                <input v-if="permit.siteInvestigation.nearbyObstacle === '있음'" type="text" class="form-control"
                       v-model="permit.siteInvestigation.nearbyObstacleMeasure" placeholder="조치내용" style="flex:1;min-width:0;">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 인양작업 줄걸이 용구 -->
    <div class="form-group row mt-20">
      <label class="col-2 form-control-label"><span>인양작업 줄걸이 용구</span></label>
      <div class="col-10 pt-2">
        <div class="mb-10" style="display:flex;align-items:center;gap:12px;">
          <label class="md-check" style="margin:0;"><input type="checkbox" v-model="permit.hasLifting"><i class="blue"></i>줄걸이 작업 있음</label>
          <button v-if="permit.hasLifting" class="btn btn-sm line-2" @click="$emit('load-lifting')">
            <i class="icon-refresh mr-3"></i>중량물작업계획서에서 가져오기
          </button>
        </div>
        <template v-if="permit.hasLifting">
          <div v-for="(lift, lIdx) in permit.liftingList" :key="lift.id" class="box mb-10">
            <div class="box-header" style="display:flex;justify-content:space-between;align-items:center;padding:8px 12px;">
              <span style="font-weight:600;">줄걸이 {{ lIdx + 1 }}</span>
              <button class="btn btn-xs line-2" @click="removeExcavationLifting(lIdx)"
                :disabled="permit.liftingList.length === 1">삭제</button>
            </div>
            <div class="box-body">
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0">인양능력 검토 결과</label>
                <div class="col-10">
                  <span class="text-888 mr-15" style="font-size:11px;">줄걸이 용구 최대 사용하중 &gt; 중량물 하중</span>
                  <label class="md-check mr-20"><input type="radio" v-model="lift.liftFeasible" value="인양가능"><i class="blue"></i>인양 가능</label>
                  <label class="md-check mr-20"><input type="radio" v-model="lift.liftFeasible" value="인양불가능"><i class="blue"></i>인양 불가능</label>
                </div>
              </div>
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0">줄걸이 용구</label>
                <div class="col-10">
                  <label class="md-check mr-20"><input type="checkbox" v-model="lift.riggingTools" value="와이어로프"><i class="blue"></i>와이어로프</label>
                  <label class="md-check mr-20"><input type="checkbox" v-model="lift.riggingTools" value="섬유로프"><i class="blue"></i>섬유로프</label>
                  <label class="md-check mr-20"><input type="checkbox" v-model="lift.riggingTools" value="체인"><i class="blue"></i>체인</label>
                  <label class="md-check mr-10"><input type="checkbox" v-model="lift.riggingToolOther"><i class="blue"></i>기타</label>
                  <input v-if="lift.riggingToolOther" type="text" class="form-control mt-5" v-model="lift.riggingToolOtherText" placeholder="기타 줄걸이 용구" style="max-width:300px;">
                </div>
              </div>
              <div class="form-group row mb-10">
                <label class="col-2 form-control-label pt-0">보조용구</label>
                <div class="col-10">
                  <label class="md-check mr-20"><input type="checkbox" v-model="lift.auxiliaryTools" value="클램프"><i class="blue"></i>클램프</label>
                  <label class="md-check mr-20"><input type="checkbox" v-model="lift.auxiliaryTools" value="해커"><i class="blue"></i>해커</label>
                  <label class="md-check mr-20"><input type="checkbox" v-model="lift.auxiliaryTools" value="체인슬링"><i class="blue"></i>체인슬링</label>
                  <label class="md-check mr-20"><input type="checkbox" v-model="lift.auxiliaryTools" value="러그"><i class="blue"></i>러그</label>
                  <label class="md-check mr-10"><input type="checkbox" v-model="lift.auxiliaryToolOther"><i class="blue"></i>기타</label>
                  <input v-if="lift.auxiliaryToolOther" type="text" class="form-control mt-5" v-model="lift.auxiliaryToolOtherText" placeholder="기타 보조용구" style="max-width:300px;">
                </div>
              </div>
              <div class="form-group row mb-0">
                <label class="col-2 form-control-label pt-0">줄걸이 세부</label>
                <div class="col-10">
                  <div class="row">
                    <div class="col-4 mb-10"><label class="wp-field-label">직경</label><input type="text" class="form-control" v-model="lift.diameter" placeholder="00 mm"></div>
                    <div class="col-4 mb-10"><label class="wp-field-label">안전작업하중</label><input type="text" class="form-control" v-model="lift.safeWorkLoad"></div>
                    <div class="col-4 mb-10"><label class="wp-field-label">줄걸이 수</label><input type="text" class="form-control" v-model="lift.riggingCount" placeholder="00 개"></div>
                    <div class="col-4"><label class="wp-field-label">하중계수(장력)</label><input type="text" class="form-control" v-model="lift.loadFactor"></div>
                    <div class="col-4"><label class="wp-field-label">안전계수</label><input type="text" class="form-control" v-model="lift.safetyFactor"></div>
                    <div class="col-4"><label class="wp-field-label">최대사용하중</label><input type="text" class="form-control" v-model="lift.maxWorkLoad"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button class="btn btn-md light-blue" @click="addExcavationLifting"><i class="icon-plus mr-5"></i>줄걸이 추가</button>
        </template>
      </div>
    </div>

    <!-- 중량물 제원 -->
    <div class="form-group row mt-20">
      <label class="col-2 form-control-label"><span>중량물 제원</span></label>
      <div class="col-10 pt-2">
        <div class="mb-10" style="display:flex;align-items:center;gap:12px;">
          <label class="md-check" style="margin:0;"><input type="checkbox" v-model="permit.hasHeavyCargo"><i class="blue"></i>중량물 취급</label>
          <button v-if="permit.hasHeavyCargo" class="btn btn-sm line-2" @click="$emit('load-cargo')">
            <i class="icon-refresh mr-3"></i>중량물작업계획서에서 가져오기
          </button>
        </div>
        <template v-if="permit.hasHeavyCargo">
          <div v-for="(cargo, cIdx) in permit.cargoList" :key="cargo.id" class="box mb-10">
            <div class="box-header" style="display:flex;justify-content:space-between;align-items:center;padding:8px 12px;">
              <span style="font-weight:600;">중량물 {{ cIdx + 1 }}</span>
              <button class="btn btn-xs line-2" @click="removeExcavationCargo(cIdx)"
                :disabled="permit.cargoList.length === 1">삭제</button>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-4 mb-10"><label class="wp-field-label">품명</label><input type="text" class="form-control" v-model="cargo.name" placeholder="철근(상세제원) 다발"></div>
                <div class="col-4 mb-10"><label class="wp-field-label">단위중량(kg)</label><input type="text" class="form-control" v-model="cargo.unitWeight" placeholder="00 kg"></div>
                <div class="col-4 mb-10"><label class="wp-field-label">종류</label><input type="text" class="form-control" v-model="cargo.type" placeholder="철근 다발, 거푸집 등"></div>
                <div class="col-4 mb-10"><label class="wp-field-label">고정방법</label><input type="text" class="form-control" v-model="cargo.fixMethod"></div>
                <div class="col-4 mb-10"><label class="wp-field-label">형상</label><input type="text" class="form-control" v-model="cargo.shape" placeholder="박스형, 묶음형 등"></div>
                <div class="col-4 mb-10"><label class="wp-field-label">총중량(kg)</label><input type="text" class="form-control" v-model="cargo.totalWeight" placeholder="00 kg"></div>
                <div class="col-4 mb-10"><label class="wp-field-label">수직 운반거리(m)</label><input type="text" class="form-control" v-model="cargo.verticalDistance" placeholder="00 m"></div>
                <div class="col-4 mb-10"><label class="wp-field-label">수평 운반거리(m)</label><input type="text" class="form-control" v-model="cargo.horizontalDistance" placeholder="00 m"></div>
                <div class="col-4 mb-10"><label class="wp-field-label">필요작업반경(m)</label><input type="text" class="form-control" v-model="cargo.workRadius" placeholder="00 m"></div>
                <div class="col-4 mb-10"><label class="wp-field-label">총 양중수량(개)</label><input type="text" class="form-control" v-model="cargo.totalQty" placeholder="00 개"></div>
                <div class="col-4 mb-10"><label class="wp-field-label">1회 양중수량(개)</label><input type="text" class="form-control" v-model="cargo.qtyPerLift" placeholder="00 개"></div>
                <div class="col-4 mb-0"><label class="wp-field-label">1회 양중중량(kg)</label><input type="text" class="form-control" v-model="cargo.weightPerLift" placeholder="00 kg"></div>
              </div>
            </div>
          </div>
          <button class="btn btn-md light-blue" @click="addExcavationCargo"><i class="icon-plus mr-5"></i>중량물 추가</button>
        </template>
      </div>
    </div>

    <!-- 작업순서 및 안전 작업 방법 -->
    <div class="form-group row mt-20">
      <label class="col-2 form-control-label"><span>작업순서 및 안전 작업 방법</span></label>
      <div class="col-10 pt-2">
        <WorkProcedureTable :procedures="permit.procedures" @load-procedures="$emit('load-procedures')" />
      </div>
    </div>

    <!-- 첨부서류 목록 -->
    <div class="form-group row mt-20">
      <label class="col-2 form-control-label"><span>첨부서류 목록</span></label>
      <div class="col-10 pt-2">
        <div v-for="doc in permit.attachmentDocs" :key="doc.key" class="mb-10">
          <div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap;">
            <label class="md-check" style="min-width:220px;">
              <input type="checkbox" v-model="doc.checked"><i class="blue"></i>{{ doc.label }}
            </label>
            <template v-if="doc.checked">
              <input type="file" multiple :id="'excav-doc-' + doc.key" style="display:none;"
                @change="handleDocFile($event, doc)">
              <button class="btn btn-sm line-2" @click="$el.querySelector('#excav-doc-' + doc.key).click()"
                :disabled="doc.maskingChecking">
                <i class="icon-upload mr-3"></i>파일 선택
              </button>
              <span v-if="doc.maskingChecking" class="text-info" style="font-size:11px;">
                <i class="fa fa-spinner fa-spin mr-3"></i>AI 가 개인정보 마스킹 여부를 확인하는 중입니다... (최대 1분 소요)
              </span>
              <div v-if="doc.rejections && doc.rejections.length" class="mt-5"
                   style="width:100%; padding:8px 10px; background:#fff5f5; border:1px solid #f5c6cb; border-radius:4px; font-size:11px; color:#721c24;">
                <div v-for="(r, ri) in doc.rejections" :key="'rej-'+ri" :class="ri ? 'mt-3' : ''">
                  <strong>[{{ r.fileName }}] 업로드 거부 — 개인정보 마스킹 미흡</strong>
                  <span v-if="r.documentSubtype"> · {{ r.documentSubtype }}</span>
                  <span v-if="r.confidence != null"> · 신뢰도 {{ Math.round(r.confidence * 100) }}%</span>
                  <span v-if="r.totalCount"> · AI {{ r.totalCount }}회 중 {{ r.rejectedCount }}회 거절</span>
                  <div>· 노출된 항목 : {{ r.exposedFields.length ? r.exposedFields.join(', ') : '(미상)' }}</div>
                  <div>· AI 평가     : {{ r.overallAssessment }}</div>
                </div>
              </div>
              <div v-if="doc.maskingError" class="mt-5" style="width:100%; padding:6px 10px; background:#fff3cd; border:1px solid #ffeeba; border-radius:4px; font-size:11px; color:#856404;">
                {{ doc.maskingError }}
              </div>
              <div v-if="doc.files && doc.files.length" style="display:flex;flex-wrap:wrap;gap:4px;">
                <span v-for="(f, fi) in doc.files" :key="fi"
                  style="font-size:11px;background:#f0f0f0;padding:2px 6px;border-radius:3px;display:flex;align-items:center;gap:4px;">
                  {{ f.name }}
                  <button class="btn btn-xs line-2" style="padding:0 4px;height:16px;line-height:14px;" @click="doc.files.splice(fi,1)">×</button>
                </span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EquipCommonFields from './EquipCommonFields.vue'
import WorkProcedureTable from './WorkProcedureTable.vue';
import docFileUploadMixin from '@/mixins/docFileUploadMixin';
export default {
  name: 'ExcavationPermit',
  components: { EquipCommonFields, WorkProcedureTable },
  mixins: [docFileUploadMixin],
  inject: { workPermitPlanId: { default: () => '' } },
  data() { return { workPermitFormKey: 'excavationPermit' }; },
  props: {
    permit: {
      type: Object,
      required: true
    },
    scheduleDateDisabledFn: {
      type: Function,
      default: () => false
    },
    signalMethodOptions: {
      type: Array,
      default: () => ['수신호', '무선', '기타']
    }
  },
  methods: {
    addExcavationOperator() {
      this.permit.operators.push({ name: '', license: '', phone: '' });
    },
    addExcavationGuide() {
      this.permit.guides.push({ name: '', signalMethods: [], phone: '', wirelessMeans: '' });
    },
    addExcavationEquipment() {
      this.permit.equipmentList.push({ id: Date.now(), hasCertificate: null, insuranceName: '', modelName: '', manufacturer: '', registrationNo: '', manufactureYear: '', insuranceStatus: '', insuranceExpiry: '', driveType: '', speedLimit: '', equipWeight: '', turningRadius: '', ratedLoad: '', maxLiftHeight: '', boomMaxHeight: '', boomLength: '', regularInspectionDate: '', inspectionExpiry: '', workDevices: [], workDeviceOther: false, workDeviceOtherText: '' });
    },
    removeExcavationEquipment(index) {
      if (this.permit.equipmentList.length > 1) this.permit.equipmentList.splice(index, 1);
    },
    addExcavationLifting() {
      this.permit.liftingList.push({ id: Date.now(), liftFeasible: '', riggingTools: [], riggingToolOther: false, riggingToolOtherText: '', auxiliaryTools: [], auxiliaryToolOther: false, auxiliaryToolOtherText: '', diameter: '', safeWorkLoad: '', riggingCount: '', loadFactor: '', safetyFactor: '', maxWorkLoad: '' });
    },
    removeExcavationLifting(index) {
      if (this.permit.liftingList.length > 1) this.permit.liftingList.splice(index, 1);
    },
    addExcavationCargo() {
      this.permit.cargoList.push({ id: Date.now(), name: '', unitWeight: '', type: '', fixMethod: '', shape: '', totalWeight: '', verticalDistance: '', horizontalDistance: '', workRadius: '', totalQty: '', qtyPerLift: '', weightPerLift: '' });
    },
    removeExcavationCargo(index) {
      if (this.permit.cargoList.length > 1) this.permit.cargoList.splice(index, 1);
    },
    // 지반 보강방법: '해당없음'은 다른 항목과 배타 선택
    onReinforceChange(r) {
      const si = this.permit.siteInvestigation;
      if (r === '해당없음' && si.reinforcementMethods.includes('해당없음')) {
        si.reinforcementMethods = ['해당없음'];
        si.reinforcementOther = false;
        si.reinforcementOtherText = '';
      } else if (r !== '해당없음' && si.reinforcementMethods.includes(r)) {
        si.reinforcementMethods = si.reinforcementMethods.filter((x) => x !== '해당없음');
      }
    },
    onReinforceOtherChange() {
      const si = this.permit.siteInvestigation;
      if (si.reinforcementOther) {
        si.reinforcementMethods = si.reinforcementMethods.filter((x) => x !== '해당없음');
      }
    },
  }
}
</script>